// Where the login page may send someone after they sign in, when an app asked
// them to connect their account (the OAuth authorize flow, backend/oauth/).
//
// ONLY a path on this site that starts with /oauth/authorize?. Anything else is
// ignored and the page falls back to its usual destination, so `next` cannot be
// used to bounce a person to another site straight after they sign in.
const OAUTH_AUTHORIZE_NEXT = /^\/oauth\/authorize\?[^\s\\]*$/;

export function safeOAuthNext(next) {
  if (typeof next !== 'string' || next.length > 4096) return null;
  return OAUTH_AUTHORIZE_NEXT.test(next) ? next : null;
}

// The checkout-recovery email's link (/audit/new?resume=<opaque ref>), so a
// signed-out click goes through sign-in and lands back on that checkout. The
// ref is the only thing allowed after it.
const RESUME_NEXT = /^\/audit\/new\?resume=[A-Za-z0-9_-]{1,64}$/;

export function safeResumeNext(next) {
  return typeof next === 'string' && RESUME_NEXT.test(next) ? next : null;
}
